import { fetchStaticLayout } from '@/actions/ecom/layout';
import PageLayout from '@/components/Layouts/PageLayout';
import useLayoutRenderer from '@/hooks/useLayoutRenderer';
import SingleImagesBanner from '@/shared/crisp/SingleImagesBanner';
import AnnualReports from '@/components/InvestorRelations/AnnualReports';
import FinancialResults from '@/shared/crisp/FinancialResults';

import ContactDetails from '@/components/InvestorRelations/ContactDetails';
import CorporateGovernance from '@/components/InvestorRelations/CorporateGovernance';

import SubsidiaryFinancials from '@/components/InvestorRelations/SubsidiaryFinancials';
import { MemoExoticComponent } from 'react';
import ssrErrorHandler from '@/errors/ssrErrorHandler';
import { NextPageContext } from 'next';
import React from 'react';

import { MapType } from '@/types';
import { CMS_COMPONENTS } from '@/constants/cms';
import AboutUs from '@/components/InvestorRelations/AboutUs';
import Vision from '@/components/InvestorRelations/Vision';

const STATIC_MAP: { [key: string]: MemoExoticComponent<any> | any } = {
  [CMS_COMPONENTS.BANNERS.SINGE_IMAGE]: SingleImagesBanner,
  [CMS_COMPONENTS.INVESTOR_RELATION.ANNUAL_REPORTS]: AnnualReports,
  [CMS_COMPONENTS.INVESTOR_RELATION.FINANCIAL_RESULTS]: FinancialResults,
  [CMS_COMPONENTS.INVESTOR_RELATION.CONTACT_DETAILS]: ContactDetails,
  [CMS_COMPONENTS.INVESTOR_RELATION.LINKS]: CorporateGovernance,
  [CMS_COMPONENTS.INVESTOR_RELATION.ABOUT_US]: AboutUs,
  [CMS_COMPONENTS.INVESTOR_RELATION.SUBSIDIARY_FINANCIALS]: SubsidiaryFinancials,
  [CMS_COMPONENTS.INVESTOR_RELATION.VISION]: Vision,
};

export async function getServerSideProps(nextPageContext: NextPageContext) {
  const promises = [
    fetchStaticLayout('investor-relations-page', {
      'populate[seo][populate]': 'metaSocial.image,metaImage',
      'populate[layout][populate]':
        'tags,cta,list.ctas,list.mobileMedia,list.desktopMedia,ctas,mobileImage,desktopImage,list.desktopImage,list.mobileImage,tabs.ctas,tabs.mobileImage,tabs.desktopImage,image,products.media,products.tags,products.featuredTag,products.dealTag,list.icon,list.image,list.tag,videoCard.video,videoCard.desktopImage,videoCard.mobileImage,slickSettings,content.desktopImage,content.mobileImage, content.ctas, features.image, list.cta,contentFlags,cta',
    }),
  ];

  try {
    let [page]: any[] = await Promise.allSettled(promises);

    if (page.status === 'fulfilled') {
      page = page.value;
    }

    return {
      props: {
        page,
      },
    };
  } catch (error) {
    return ssrErrorHandler(error, nextPageContext);
  }
}

export default function InvestorRelationsPage({ page }: { page: any; componentProps: MapType }) {
  const layout = useLayoutRenderer(page.layout, STATIC_MAP);

  return (
    <PageLayout seo={page.seo} topPadding>
      {layout}
    </PageLayout>
  );
}
